module.exports = __webpack_public_path__ + "img/up.23a46cc3.svg";